import Vue from 'vue'
import App from './App'
import router from '../router/index'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

/*
    *cookies操作
    * this.$cookies.set(keyName, value[, expireTimes[, path[, domain[, secure]]]])
    * this.$cookies.get(keyName)
    * this.$cookies.remove(keyName [, path [, domain]])
    * this.$cookies.isKey(keyName)    检查是否存在
    * this.$cookies.keys()  获取所有key
*/



// WEBPACK FOOTER //
// ./src/view/main.js